/**
* Created by lobin on 2020/6/18.
*/
<template>
  <div class="cabinet-add">
    <a-modal v-model="visible" title="编辑格子添加模板(单组)" @ok="handleOk" width="800px" @cancel="cancelHandle">
      <a-table :columns="columns" :data-source="data" bordered size="middle" :pagination="false" :scroll="{ y: 300 }" rowKey="_id">
        <template
            v-for="col in ['serial', 'channel']"
            :slot="col"
            slot-scope="text, record"
        >
          <div>
            <a-input-number
                v-if="record.editable"
                style="margin: -5px 0"
                :value="text"
                @change="e => handleChange(e.target.value, record.key, col)"
            />
            <template v-else>
              {{ text }}
            </template>
          </div>
        </template>
        <template
            slot="type"
            slot-scope="text, record"
        >
          <div>
            <a-radio-group
                v-if="record.editable"
                default-value="small"
                button-style="solid"
                style="margin: -5px 0"
                :value="text"
                @change="e => handleChange(e.target.value, record.key, 'type')"
            >
              <a-radio-button value="mini">迷你</a-radio-button>
              <a-radio-button value="small">小</a-radio-button>
              <a-radio-button value="middle">中</a-radio-button>
              <a-radio-button value="big">大</a-radio-button>
              <a-radio-button value="huge">超大</a-radio-button>
            </a-radio-group>
            <template v-else>
              <span v-if="text === 'mini'">迷你</span>
              <span v-if="text === 'small'">小</span>
              <span v-if="text === 'middle'">中</span>
              <span v-if="text === 'big'">大</span>
              <span v-if="text === 'huge'">超大</span>
            </template>
          </div>
        </template>
        <template slot="action" slot-scope="text, record">
          <div class="editable-row-operations">
        <span v-if="record.editable">
          <a @click="() => save(record.key)">保存</a>
          <a-divider type="vertical" />
          <a @click="cancel(record.key)">取消</a>
        </span>
        <span v-else>
          <a :disabled="editingKey !== ''" @click="() => edit(record.key)">编辑</a>
          <a-divider type="vertical" />
          <a :disabled="editingKey !== ''" @click="() => del(record.key)">删除</a>
        </span>
          </div>
        </template>
      </a-table>
      <a-button type="dashed" icon="plus" style="width:100%;margin-top: 10px" @click="addItem">
        添加
      </a-button>
    </a-modal>
  </div>
</template>

<script type="text/babel">
import { companyDetail, companyModify } from '@/api/company';

function isNumber(obj) {
  return Object.prototype.toString.call(obj) === '[object Number]';
}

const columns = [
  {
    title: '编号',
    dataIndex: 'serial',
    scopedSlots: { customRender: 'serial' },
  },
  {
    title: '规格',
    className: 'type',
    dataIndex: 'type',
    width: 280,
    scopedSlots: { customRender: 'type' },
  },
  {
    title: '通道',
    dataIndex: 'channel',
    scopedSlots: { customRender: 'channel' },
  },
  {
    title: '操作',
    scopedSlots: { customRender: 'action' },
  },
];
export default {
  data() {
    return {
      companyId: '',
      num: 22,
      visible: false,
      data: [],
      columns,
      detail: {},
      editingKey: '',
    };
  },
  methods: {
    addItem() {
      const listLength = this.data.length + 1;
      this.data.push({
        key: listLength,
        serial: listLength,
        type: 'small',
        channel: listLength,
      });
    },
    show(companyId) {
      this.companyId = companyId;
      this.getTmp();
      this.visible = true;
    },
    handleChange(value, key, column) {
      const newData = [...this.data];
      const target = newData.filter((item) => key === item.key)[0];
      if (target) {
        target[column] = value;
        this.data = newData;
      }
    },
    async getTmp() {
      const { data } = await companyDetail(this.companyId);
      if (data.cabinetTmp) {
        this.data = data.cabinetTmp;
      }
      this.detail = data;
    },
    del(key) {
      const newData = [];
      for (let i = 0; i < this.data.length; i += 1) {
        const item = this.data[i];
        if (item.key !== key) {
          newData.push(item);
        }
      }
      this.data = newData;
    },
    save(key) {
      const newData = [...this.data];
      const newCacheData = [...this.data];
      const target = newData.filter((item) => key === item.key)[0];
      if (this.checkListItem(target)) {
        const targetCache = newCacheData.filter((item) => key === item.key)[0];
        if (target && targetCache) {
          delete target.editable;
          this.data = newData;
          Object.assign(targetCache, target);
          this.data = newCacheData;
        }
        this.editingKey = '';
      }
    },
    checkListItem({ serial, type, channel }) {
      let res = true;
      if (!isNumber(serial)) {
        res = false;
        this.$message.error('编号必须为数字');
      }
      if (!isNumber(channel)) {
        res = false;
        this.$message.error('通道必须为数字');
      }
      if (!['small', 'middle', 'big'].includes(type)) {
        res = false;
        this.$message.error('规格必须是small|middle|big');
      }
      return res;
    },
    cancel(key) {
      const newData = [...this.data];
      const target = newData.filter((item) => key === item.key)[0];
      this.editingKey = '';
      if (target) {
        Object.assign(target, this.data.filter((item) => key === item.key)[0]);
        delete target.editable;
        this.data = newData;
      }
    },
    edit(key) {
      const newData = [...this.data];
      const target = newData.filter((item) => key === item.key)[0];
      this.editingKey = key;
      if (target) {
        target.editable = true;
        this.data = newData;
      }
    },
    async handleOk() {
      const { data } = await companyModify(this.companyId, {
        ...this.detail,
        cabinetTmp: this.data,
      });
      if (data) {
        this.cancelHandle();
        this.$message.success('编辑成功');
      }
    },
    cancelHandle() {
      this.visible = false;
    },
  },
};

</script>

<style lang="less" rel="stylesheet/less">
.station {
}
</style>
